import {
  useProjectBuildingGFA,
  useProjectName,
} from '@client/store/project/project.hook';
import { getDisplayNumber } from '@shared/helpers/display/get-display-number.helper';
import { EllipsisText } from '@ui/EllipsisText/EllipsisText';
import { Box, Typography } from '@mui/material';
import React from 'react';
import { makeStyles } from 'tss-react/mui';

/**
 * Renders the current project name. Navigation is handled by the parent
 * {@link AppBarElementId.ProjectSelectorContainer} container.
 */
export const ProjectSelectorButton: React.FC<{ hideGfa?: boolean }> = ({
  hideGfa = false,
}) => {
  const { classes } = useStyles();
  const projectName = useProjectName();
  const gfa = useProjectBuildingGFA();
  const [showGfa, setShowGfa] = React.useState(!hideGfa);

  React.useEffect(() => {
    if (hideGfa) {
      setShowGfa(false);
      return;
    }

    const timeoutId = window.setTimeout(() => setShowGfa(true), 160);
    return () => window.clearTimeout(timeoutId);
  }, [hideGfa]);

  return (
    <Box className={classes.root}>
      <EllipsisText className={classes.projectName}>{projectName}</EllipsisText>
      {!hideGfa && showGfa && (
        <Typography component="span" className={classes.gfa}>
          {getDisplayNumber(gfa, { decimals: 0 })} m²
        </Typography>
      )}
    </Box>
  );
};

const useStyles = makeStyles()(() => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    gap: 24,
    minWidth: 0,
    transform: 'translateY(1px)',
  },
  projectName: {
    fontSize: 12,
    fontWeight: 500,
    lineHeight: 1,
    opacity: 0.8,
    color: '#1c1c1c',
    maxWidth: 200,
    minWidth: 0,
  },
  gfa: {
    flexShrink: 0,
    color: 'rgba(0,0,0,0.5)',
    fontSize: 12,
    fontWeight: 400,
    lineHeight: 1,
    whiteSpace: 'nowrap',
  },
}));
